import { useCallback } from 'react';
import { useAppToast } from '~/app/components/NextApp/lib/CoreUi';
import { useI18n } from '~/app/lib/i18n';
import { useTracker } from '~/app/lib/tracker/useTracker';
import { toLinkType } from '~/app/lib/utils/analytics';
import copyToClipboard from '~/app/lib/utils/copyToClipboard';

const useCopyShareUrl = (shareUrl: string | undefined) => {
  const { t } = useI18n();
  const { trackEvent } = useTracker();
  const toast = useAppToast();

  return useCallback(() => {
    if (!shareUrl) return;

    copyToClipboard(shareUrl);

    trackEvent({
      type: 'link-copied',
      linkType: toLinkType(shareUrl!),
    });

    toast({ text: t('item.events.linkCopied') });
  }, [shareUrl]);
};

export default useCopyShareUrl;
